import React from 'react'
import { IconVideo, IconPlayFilled } from 'components/Zui/Icon'
import './index.css'

const Video = ({ imgUrl, onClick }) => {
    return (
        <div className="thumbnail-video-wrap" onClick={onClick}>
            <img src={imgUrl} alt="" />
            <div className="video-icon-wrapper">
                <div className="video-icon-box">
                    <IconVideo size="l" className="thumbnail-icon-light-white" />
                </div>
            </div>

            <div className="play-icon-wrapper">
                <div className="play-icon-conatiner">
                    <IconPlayFilled size="l" className="thumbnail-icon-light-white" />
                </div>
            </div>
        </div>
    )
}

export default Video
